export const reactSelectLight = {
  control: (base, state) => ({
    ...base,
    // Matches the muted, unmistakably-locked look .ev-form--edit gives every
    // other disabled input — react-select draws its own control, so it needs
    // the same treatment spelled out explicitly rather than inheriting it.
    borderColor: state.isDisabled ? '#dbe1e8' : state.isFocused ? '#0e4535' : '#ced4da',
    backgroundColor: state.isDisabled ? '#eef1f5' : '#ffffff',
    opacity: 1,
    // react-select's own base style sets pointerEvents: 'none' on a disabled
    // control — that stops the element from ever being hovered, so the
    // not-allowed cursor below never gets a chance to render. Restoring
    // pointer-events lets the hover (and its cursor) land, while isDisabled
    // still blocks the actual open/select interaction on react-select's side.
    pointerEvents: 'auto',
    // Matches $input-border-radius — react-select draws its own control, so it
    // doesn't inherit the Bootstrap variable.
    borderRadius: 8,
    minHeight: '42px',
    color: '#000000',
    boxShadow: 'none',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    '&:hover': {
      borderColor: state.isDisabled ? '#dbe1e8' : '#0e4535'
    }
  }),

  menu: (base) => ({
    ...base,
    backgroundColor: '#ffffff',
    color: '#000000',
    borderRadius: 6,
    marginTop: 4,
    zIndex: 9999
  }),

  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected ? '#e8f0ed' : isFocused ? '#e8f0ed' : '#ffffff',
    color: isSelected ? '#0e4535' : '#000000',
    fontWeight: isSelected ? 600 : 400,
    cursor: 'pointer',
    fontSize: '0.85rem',
    // ...base carries react-select's default ':active' of #B2D4FF, so an option
    // flashed blue while the mouse was held down however the rest was themed.
    ':active': { backgroundColor: '#d6e5df' }
  }),

  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#5b6472' : '#000000',
    cursor: state.isDisabled ? 'not-allowed' : 'default'
  }),

  multiValue: (base) => ({
    ...base,
    backgroundColor: '#e8f0ed',
    borderRadius: 4
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: '#0e4535',
    fontWeight: 500,
    fontSize: '0.82rem'
  }),

  multiValueRemove: (base) => ({
    ...base,
    color: '#0e4535',
    '&:hover': {
      backgroundColor: '#0e4535',
      color: '#ffffff'
    }
  }),

  placeholder: (base, state) => ({
    ...base,
    color: '#6c757d',
    cursor: state.isDisabled ? 'not-allowed' : 'default'
  }),

  valueContainer: (base, state) => ({
    ...base,
    minHeight: '32px',
    padding: '0 6px',
    cursor: state.isDisabled ? 'not-allowed' : 'default'
  }),

  indicatorsContainer: (base, state) => ({
    ...base,
    minHeight: '32px',
    cursor: state.isDisabled ? 'not-allowed' : 'default'
  }),

  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#9aa5b1' : base.color,
    cursor: state.isDisabled ? 'not-allowed' : 'pointer'
  }),

  indicatorSeparator: (base, state) => ({
    ...base,
    backgroundColor: state.isDisabled ? '#dbe1e8' : base.backgroundColor
  })
};
